import { render, staticRenderFns } from "./day-of-month.vue?vue&type=template&id=bfe1cf70&"
import script from "./day-of-month.vue?vue&type=script&lang=js&"
export * from "./day-of-month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports